import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const GET_CONFIGURACAO_MASTER = "getConfiguracaoMaster";

const state = {};

const getters = {};

const actions = {
    [GET_CONFIGURACAO_MASTER](context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("configuracaoMaster", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

const mutations = {};

export default {
    state,
    actions,
    mutations,
    getters
};